import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { UnsavedStructureModal } from "@src/components/organisms/modals/unsaved-structure-modal/unsaved-structure-modal";

export const UnsavedStructure = () => {
  const showUnsavedStructureModal = useSelector(
    (state: RootState) =>
      state.yourSlice.unsavedStructureModal.showUnsavedStructureModal,
  );

  return <>{showUnsavedStructureModal && <UnsavedStructureModal />}</>;
};
